export const TASK_FORM_FIELD_LABELS = {
    title: 'Título',
    description: 'Descripción',
    priority: 'Prioridad',
    activation: 'Fecha de activación',
    due: 'Fecha límite de entrega',
};

export const TASK_DESCRIPTION_MAX = 1000;

export const createEmptyTaskFormErrors = () => ({
    title: '',
    description: '',
    priority: '',
    activation: '',
    due: '',
});

const quoteFieldLabel = (label) => `«${label}»`;

export const buildTaskValidationToastMessage = (missingLabels) => {
    const count = missingLabels.length;

    if (count === 0) return '';
    if (count === 1) {
        return `Completa ${quoteFieldLabel(missingLabels[0])} para guardar la tarea.`;
    }
    if (count === 2) {
        return `Completa ${quoteFieldLabel(missingLabels[0])} y ${quoteFieldLabel(missingLabels[1])} para guardar la tarea.`;
    }

    return `Faltan ${count} campos obligatorios. Revisa el aviso al inicio del formulario.`;
};

/**
 * @param {object} form
 * @param {{ combineDateTime: (date: Date, time: string) => Date }} helpers
 */
export const validateTaskFormValues = (form, { combineDateTime }) => {
    const errors = createEmptyTaskFormErrors();
    const description = String(form.description || '');

    if (!form.title?.trim()) {
        errors.title = 'Ingresa un título para la tarea.';
    }

    if (!description.trim()) {
        errors.description = 'Describe qué deben entregar los alumnos.';
    } else if (description.length > TASK_DESCRIPTION_MAX) {
        errors.description = `La descripción no puede superar ${TASK_DESCRIPTION_MAX.toLocaleString('es-MX')} caracteres.`;
    }

    if (!form.priority) {
        errors.priority = 'Selecciona la prioridad de la tarea.';
    }

    if (!form.activationDate) {
        errors.activation = 'Selecciona la fecha y hora de activación.';
    }

    if (!form.dueDate) {
        errors.due = 'Selecciona la fecha y hora límite de entrega.';
    }

    if (form.activationDate && form.dueDate) {
        const activation = combineDateTime(form.activationDate, form.activationTime || '08:00');
        const due = combineDateTime(form.dueDate, form.dueTime || '23:59');

        if (due.getTime() <= activation.getTime()) {
            errors.due = 'La fecha límite debe ser posterior a la fecha de activación.';
        }
    }

    const isValid = !Object.values(errors).some(Boolean);

    return { isValid, errors };
};
